import { QueryClient, queryClientOptions } from '@ctct/data-query';
import {
  isServer,
  QueryClient as ReactQueryClient,
  QueryClientProvider as ReactQueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { type ReactNode } from 'react';

const QueryClientProvider = ({ children }: { children: ReactNode }) => {
  const getQueryClient = () => {
    if (isServer) {
      return new ReactQueryClient({
        defaultOptions: queryClientOptions,
      });
    }
    return QueryClient.getInstance();
  };

  return (
    <ReactQueryClientProvider client={getQueryClient()}>
      <ReactQueryDevtools />
      {children}
    </ReactQueryClientProvider>
  );
};

export { QueryClientProvider };
